import { HiClipboardList, HiDocumentText, HiCurrencyDollar, HiTruck, HiCheckCircle } from 'react-icons/hi';

export const importSteps = [
  {
    icon: HiClipboardList,
    titleEn: 'Register as Importer',
    descEn: 'Sign up as an importer with AFIP to get started.',
    titleEs: 'Registrarse como Importador',
    descEs: 'Inscríbase como importador en AFIP para comenzar.',
    link: 'https://www.afip.gob.ar/registroAduanero/registro/inscripcion.asp',
  },
  {
    icon: HiDocumentText,
    titleEn: 'Request a Quotation',
    descEn: 'Contact us to receive a detailed quotation for your equipment.',
    titleEs: 'Solicite una Cotización',
    descEs: 'Contáctenos para recibir una cotización detallada de su equipo.',
  },
  {
    icon: HiCurrencyDollar,
    titleEn: 'Approve & Pay',
    descEn: 'Approve your quote and make the payment securely.',
    titleEs: 'Aprobar y Pagar',
    descEs: 'Apruebe su cotización y realice el pago de forma segura.',
  },
  {
    icon: HiTruck,
    titleEn: 'Shipping & Customs',
    descEn: 'We handle shipping and customs clearance for you.',
    titleEs: 'Envío y Aduana',
    descEs: 'Nos encargamos del envío y despacho aduanero por usted.',
  },
  {
    icon: HiCheckCircle,
    titleEn: 'Receive Your Machinery',
    descEn: 'Your equipment arrives ready for use in Argentina.',
    titleEs: 'Reciba su Maquinaria',
    descEs: 'Su equipo llega listo para usar en Argentina.',
  },
];
